/* eslint-disable */
import { 
    greenThemeLight, greenThemeDark,transparentTheme, bwThemeLight, bwThemeDark, blueThemeLight, blueThemeDark, redThemeLight, redThemeDark, orangeThemeLight, orangeThemeDark, purpleThemeLight, purpleThemeDark, pinkThemeLight, pinkThemeDark, yellowThemeLight, yellowThemeDark
} from '../theme/theme'


export const themeData = {
  theme: bwThemeDark,
};


// Choose theme from above